module.exports = "<div class=\"pmd-card pmd-z-depth statistics-content\">\n  <div class=\"pmd-card-body\" [innerHTML]=\"keterangan | safeHtml\">\n\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/wellcome/wellcome.component.html
// module id = ./src/app/components/wellcome/wellcome.component.html
// module chunks = main